import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const medicinaLaboralRoutes: Routes = [
  {
    path: "ml_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioMedicinaLaboralComponent,
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_categoria-antecedentes",
    loadComponent: () =>
      import("./components/categoria-antecedentes/categoria-antecedentes.component").then(
        (m) => m.CategoriaAntecedentesComponent,
      ),
    data: {
      label: "Categorías de Antecedentes",
      icon: "category",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_categoria-antecedentes/antecedentes",
    loadComponent: () =>
      import("./components/categoria-antecedentes/antecedentes/antecedentes.component").then(
        (m) => m.AntecedentesComponent,
      ),
    data: {
      label: "Antecedentes por Categoría",
      icon: "category",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_clases-eventos-salud",
    loadComponent: () =>
      import("./components/eventos-salud/clases/clases-eventos-salud.component").then(
        (m) => m.ClasesEventosSaludComponent,
      ),
    data: {
      label: "Clases de Eventos de Salud",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_clases-eventos-salud/eventos-clase",
    loadComponent: () =>
      import("./components/eventos-salud/eventos/eventos-clase.component").then(
        (m) => m.EventosClaseComponent,
      ),
    data: {
      label: "Eventos por Clase de Evento de Salud",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_motivos-eventos-salud",
    loadComponent: () =>
      import("./components/eventos-salud/motivos/motivos-eventos-salud.component").then(
        (m) => m.MotivosEventosSaludComponent,
      ),
    data: {
      label: "Motivos de Eventos de Salud",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_motivo-cambio-salud",
    loadComponent: () =>
      import("./components/eventos-salud/motivos-cambio/motivos-cambio.component").then(
        (m) => m.MotivosCambioComponent,
      ),
    data: {
      label: "Motivos de Cambio en Eventos",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_frecuencias",
    loadComponent: () =>
      import("./components/frecuencias/frecuencias.component").then(
        (m) => m.FrecuenciasComponent,
      ),
    data: {
      label: "Frecuencias",
      icon: "schedule",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_turnos",
    loadComponent: () =>
      import("./components/turnos/turnos.component").then(
        (m) => m.TurnosComponent,
      ),
    data: {
      label: "Turnos",
      icon: "schedule",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estados-salud",
    loadComponent: () =>
      import("./components/eventos-salud/estados/estados-salud.component").then(
        (m) => m.EstadosSaludComponent,
      ),
    data: {
      label: "Estados de Eventos de Salud",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_eventos",
    loadComponent: () =>
      import("./components/eventos/eventos.component").then(
        (m) => m.EventosComponent,
      ),
    data: {
      label: "Eventos",
      icon: "local_hospital",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios",
    loadComponent: () =>
      import("./components/estudios/estudios.component").then(
        (m) => m.EstudiosComponent,
      ),
    data: {
      label: "Estudios",
      icon: "biotech",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios/costos",
    loadComponent: () =>
      import("./components/estudios/costos-estudio/costos-estudio.component").then(
        (m) => m.CostosEstudioComponent,
      ),
    data: {
      label: "Costos por Estudio",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios/resultados",
    loadComponent: () =>
      import("./components/estudios/resultados-estudio/resultados-estudio.component").then(
        (m) => m.ResultadosEstudioComponent,
      ),
    data: {
      label: "Resultados por Estudio",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios/frecuencias",
    loadComponent: () =>
      import("./components/estudios/frecuencias-estudio/frecuencias-estudio.component").then(
        (m) => m.FrecuenciasEstudioComponent,
      ),
    data: {
      label: "Frecuencias por Estudio",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_costo_eventos",
    loadComponent: () =>
      import("./components/eventos-salud/costo-eventos/costo-eventos.component").then(
        (m) => m.CostoEventosComponent,
      ),
    data: {
      label: "Costo de Eventos",
      icon: "attach_money",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios-preventivos-legajo",
    loadComponent: () =>
      import("./components/estudios-preventivos/estudios-preventivos.component").then(
        (m) => m.EstudiosPreventivosComponent,
      ),
    data: {
      label: "Estudios Preventivos por Legajo",
      icon: "assignment_ind",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_consulta-antecedentes-salud",
    loadComponent: () =>
      import(
        "./components/consulta-antecedentes-salud/consulta-antecedentes-salud.component"
      ).then((m) => m.ConsultaAntecedentesSaludComponent),
    data: {
      label: "Consulta de Antecedentes de Salud",
      icon: "manage_search",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_antecedentes-salud",
    loadComponent: () =>
      import("./components/antecedentes-salud/antecedentes-salud.component").then(
        (m) => m.AntecedenteSaludComponent,
      ),
    data: {
      label: "Antecedentes de Salud",
      icon: "medical_information",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios-preventivos",
    loadComponent: () =>
      import(
        "./components/estudios-preventivos/generacion/generacion.component"
      ).then((m) => m.GeneracionComponent),
    data: {
      label: "Generación de Estudios Preventivos",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_estudios-preventivos-persona",
    loadComponent: () =>
      import(
        "./components/estudios-preventivos/generacion-persona/generacion-persona.component"
      ).then((m) => m.GeneracionPersonaComponent),
    data: {
      label: "Generación de Estudios por Persona",
      icon: "medical_services",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_ficha-medica",
    loadComponent: () =>
      import("./components/ficha-medica/ficha-medica.component").then(
        (m) => m.FichaMedicaComponent,
      ),
    data: {
      label: "Ficha Médica",
      icon: "medical_information",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "ml_historia-clinica",
    loadComponent: () =>
      import("./components/historia-clinica/historia-clinica.component").then(
        (m) => m.HistoriaClinicaComponent,
      ),
    data: {
      label: "Historia Clínica",
      icon: "assignment_ind",
      urlexterna: "ML",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
